import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a0b4c3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center text-sm font-sans notification" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Connect your wallet above to mint a new NFT. ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl text-white font-sans grid justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Rendering video and minting your NFT...")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-4/12" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://res.cloudinary.com/djrfhrpvq/image/upload/v1639505860/vibes/loader_cwrmpb.svg",
      class: "mt-5"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-normal" }, "(this usually takes 2-3 minutes. DO NOT CLOSE THIS WINDOW.)")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_marquee = _resolveComponent("marquee")!
  const _component_NotifyError = _resolveComponent("NotifyError")!
  const _component_NotifyInfo = _resolveComponent("NotifyInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isConnected)
      ? (_openBlock(), _createBlock(_component_NotifyError, {
          key: 0,
          class: "italic font-bold text-2xl text-shadow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_marquee, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_NotifyError, {
          key: 1,
          class: "italic font-bold text-shadow"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Uh oh something went wrong - " + _toDisplayString(_ctx.error) + ". See console for more details. ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isLoading && !_ctx.isMinted)
      ? (_openBlock(), _createBlock(_component_NotifyInfo, { key: 2 }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}